import { render, staticRenderFns } from "./AlcadasCompra.vue?vue&type=template&id=45e3e1ab&"
import script from "./AlcadasCompra.vue?vue&type=script&lang=js&"
export * from "./AlcadasCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports